import script from "./BodorNextNav.vue?vue&type=script&setup=true&lang=js"
export * from "./BodorNextNav.vue?vue&type=script&setup=true&lang=js"

import "./BodorNextNav.vue?vue&type=style&index=0&id=037faa40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-037faa40"]])

export default __exports__